import { render, staticRenderFns } from "./Workflow_component.vue?vue&type=template&id=3d1c7576"
import script from "./Workflow_component.vue?vue&type=script&lang=js"
export * from "./Workflow_component.vue?vue&type=script&lang=js"
import style0 from "./Workflow_component.vue?vue&type=style&index=0&id=3d1c7576&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports